import { useEffect, useRef } from "react";

const TrustPilot1 = () => {
  const ref = useRef(null);

   useEffect(() => {
     const script = document.createElement("script");
     script.src =
       "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
     script.async = true;
     document.body.appendChild(script);

     script.onload = () => {
       if (window.Trustpilot && ref.current) {
         window.Trustpilot.loadFromElement(ref.current, true);
       }
     };

     return () => {
       document.body.removeChild(script);
     };
   }, []);

  return (
    <div
      ref={ref}
      className="trustpilot-widget"
      data-locale="en-US"
      data-template-id="53aa8807dec7e10d38f59f32"
      data-businessunit-id="6278def99c36a16dd3a56574"
      data-style-height="150px"
      data-style-width="100%"
    >
      <a
        href="https://www.trustpilot.com/review/frankporter.com"
        target="_blank"
        rel="noopener noreferrer"
      >
        Trustpilot
      </a>
    </div>
  );
};

export default TrustPilot1;
